import { BaseWebComponentDataProviderFactory } from '../../../framework/BaseWebComponentDataProviderFactory';
import { API_TYPE_GZ } from '../../../webcomponents.constants';
import { ResponseGridViewDataProvider } from '../dataProvider/ResponseGridViewDataProvider';

export class ResponseGridDataProviderFactory extends BaseWebComponentDataProviderFactory {
  public constructor() {
    super();

    this.map.set(API_TYPE_GZ, ResponseGridViewDataProvider);
  }
}
